import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import backend from "../../api";
import { Notification } from "../../utils";
import useFormState from "../../utils/useFormState";

const ForgetPassword = () => {
  const { handleSubmit, register, errors, getValues } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const {
    formValues,
    handleChange,
    isButtonDisabled,
    setFormValues,
  } = useFormState({
    email: "",
    full_name: "",
  });

  const changePassword = () => {
    const val = formValues;
    setIsSubmitting(true);
    // if (val) {
    //   backend.get("/user/role", { params: { val } }).then(({ data }) => {
    //     if (data.data.role === "member") {
    //       history.push(`${process.env.PUBLIC_URL}/forget-password/member`);
    //     } else {
    backend
      .post("/user/password/forgot", { email: val.email })
      .then(({ data: { data, message } }) => {
        const status = new Notification();
        status.set_toast("success", message);
        status.show_toast("Please check your email");
      })
      .catch((err) => {
        const status = new Notification();
        status.set_toast("error", err.response.data.message);
        status.show_toast();
      })
      .finally(() => {
        setIsSubmitting(false);
      });

    // }
    // });

    //   backend
    //   .put('/user/password/forget',val)
    //   .then(({ data: { data, message } }) => {
    //     const status = new Notification()
    //     status.set_toast('success', message)
    //     status.show_toast()
    //   })
    //   .catch((err) => console.log(err.response.data.message))
    // }
  };
  return (
    <div>
      <Breadcrumb title={"forget password"} />
      {/*Forget Password section*/}
      <section className="pwd-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <h2>Forget Your Password?</h2>
              <form className="theme-form">
                <div className="form-row">
                  <div className="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formValues.email}
                      onChange={handleChange}
                      placeholder="Enter Your Email"
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                        pattern: {
                          value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                          message: "This must be a valid Email",
                        },
                      })}
                    />
                    <label htmlFor="email" className="error">
                      {errors.email && errors.email.message}
                    </label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-md-12">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="full_name"
                      placeholder="Enter Your Name"
                      value={formValues.full_name}
                      onChange={handleChange}
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="name" className="error">
                      {errors.full_name && errors.full_name.message}
                    </label>
                  </div>
                </div>
                <br />
                <button
                  className="btn btn-solid"
                  onClick={handleSubmit(changePassword)}
                  disabled={isSubmitting || isButtonDisabled}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
                <Link className="ml-2" to={`${process.env.PUBLIC_URL}/contact`}>
                  need help?
                </Link>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ForgetPassword;
